var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Headers
 */
import { H1, H2, H3, H4, H5, Hero } from './atoms/headers/remHeaders';
/**
 * Paragraphs
 */
import { ParagraphBody, ParagraphLead, ParagraphSubHeading } from './atoms/paragraphs/remParagraphs';
/**
 * Labels
 */
import { LabelSmall, LabelMedium, LabelLarge, LabelExtraLarge } from './atoms/labels/remLabels';
/**
 * Special
 */
import { Caption, CaptionLarge } from './atoms/special/Captions/remCaptions';
import { TextLink } from './atoms/special/TextLink/remTextLink';
import { AnchorFooterLink } from './atoms/special/AnchorFooterLink/remAnchorFooterLink';
var headers = { hero: Hero, h1: H1, h2: H2, h3: H3, h4: H4, h5: H5 };
export var typographyRem = __assign(__assign({}, headers), { labelSmall: LabelSmall, labelMedium: LabelMedium, labelLarge: LabelLarge, labelExtraLarge: LabelExtraLarge, paragraphBody: ParagraphBody, paragraphLead: ParagraphLead, paragraphSubHeading: ParagraphSubHeading, anchorFooterLink: AnchorFooterLink, caption: Caption, captionLarge: CaptionLarge, textLink: TextLink });
